<template>
  <div class="content">
    <div class="flex-line" style="position: relative">
      <div class="title1">物联网设备数据/占比</div>
    </div>
    <Echart
      v-if="data"
      :options="chartOption"
      id="iotDeviceChart"
      width="100%"
      height="730px"
      style="margin-top: -100px"
    ></Echart>
  </div>
</template>

<script>
import Echart from "@/common/echart";
const bcolors = ["#2FAEAC","#548CE3"];
const colors = [
  {
    type: "linear",
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      {
        offset: 0,
        color: "#2FAEAC", // 0% 处的颜色
      },
      {
        offset: 1,
        color: "#2FAEAC30", // 100% 处的颜色
      },
    ],
  },
  {
    type: "linear",
    x: 0,
    y: 0,
    x2: 0,
    y2: 1,
    colorStops: [
      {
        offset: 0,
        color: "#548CE3", // 0% 处的颜色
      },
      {
        offset: 1,
        color: "#548CE330", // 100% 处的颜色
      },
    ],
  },
];
export default {
  data() {
    return {
      curIdx: 0,
      chartOption: {
        color: colors,
        tooltip: {
          show: false,
        },
        grid: {
          top: 200,
          left: 100,
          right: 100,
          bottom: 50,
        },
        legend: {
          data: ["数量", "占比"],
          show: true,
          z: 10,
          top: 0,
          left: "right",
          padding: 10,
          itemGap: 40,
          itemWidth: 50,
          itemHeight: 50,
          textStyle: {
            color: "#697c94",
            fontSize: 50,
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            axisLabel: {
              color: "#697c94",
              fontSize: 40,
            },
            // prettier-ignore
            data: ['空气感知套件', '气象站', '控制柜', '灌溉控制器','土壤感知套件','控制摄像头'],
          },
        ],
        yAxis: [
          {
            type: "value",
            nameGap: 40,
            position: "left",
            alignTicks: true,
            axisLine: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#697c94",
                width: 3,
              },
            },
            axisLabel: {
              color: "#697c94",
              fontSize: 40,
            },
          },
          {
            type: "value",
            nameGap: 40,
            position: "left",
            alignTicks: true,
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
        ],
        series: [
          {
            barWidth:150,
            name: "数量",
            type: "pictorialBar",
            symbol: "path://M0,10 L10,10 L5,0 L0,10 z",
            data: [580, 320, 480, 640, 410, 500],
            label: {
              show: true,
              position: [-50, -30],
              fontSize: 40,
              color: "white",
              padding: [10, 20, 10, 10],
              borderRadius: [0, 30, 30, 0],
              backgroundColor: bcolors[0],
            },
          },
          {
            barWidth:150,
            barGap: "-40%",
            name: "占比",
            type: "pictorialBar",
            yAxisIndex: 1,
            symbol: "path://M0,10 L10,10 L5,0 L0,10 z",
            data: [12, 10, 11, 16, 12, 14],
            label: {
              show: true,
              position: [100, -30],
              formatter: "{c}%",
              fontSize: 40,
              color: "white",
              padding: [10, 10, 10, 20],
              borderRadius: [30, 0, 0, 30],
              backgroundColor: bcolors[1],
            },
          },
        ],
      },
    };
  },
  components: { Echart },
  props: {
    data: {},
  },
  watch: {
    data: {
      handler(val) {
        this.refreshChart(val);
      },
    },
   },
  mounted() {
    if (this.data) {
      this.refreshChart(this.data);
    }
    setInterval(() => {
      this.changeIdx();
    }, 3000);
  },
  methods: {
    changeIdx() {
      this.curIdx++;
      if (this.curIdx >= 3) {
        this.curIdx = 0;
      }
      this.refreshChart(this.data);
    },
    refreshChart(data) {
      var opt = Object.assign({}, this.chartOption);
      opt.series[0].data = data[this.curIdx].qty;
      opt.series[1].data = data[this.curIdx].percent;
      this.chartOption = opt;
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #244b66;
  line-height: 1;
}
.title1 {
  font-size: 75px;
  margin-bottom: 20px;
}
.changeBtn {
  width: 300px;
  height: 72px;
  border: solid 4px #697c94;
  margin-right: 20px;
  font-size: 50px;
  line-height: 70px;
  text-align: center;
  cursor: pointer;
  transition: color 1s, background-color 1s;

  &.active {
    background-color: #528be4;
    color: white;
  }
}
</style>
